import * as actionTypes from "../actions/actionsTypes";

const initialState = {
  raceSeriesData: {
    data: [],
  },
};

export const raceSeriesReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.FETCH_RACE_DAYS_SERIES:
      return {
        ...state,
        raceSeriesData: action.payload,
      };
    default:
      return state;
  }
};
